// extracted by mini-css-extract-plugin
export var contentWrap = "fc-featured-blocks-module--contentWrap--d82da";
export var grid = "fc-featured-blocks-module--grid--8896d";
export var heading = "fc-featured-blocks-module--heading--3116f";
export var image = "fc-featured-blocks-module--image--ff6b9";
export var root = "fc-featured-blocks-module--root--6284f";
export var switchOrder = "fc-featured-blocks-module--switchOrder--654dc";
export var text = "fc-featured-blocks-module--text--6d082";